import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Mail } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { goToAuthorityOrMainApp, setLanguage } from '@/shared/actions';
import { getLanguage } from '@/services/GRNLwithoutDep';
import { translate } from '@/services/TranslationService';
import store from '@/services/store';
import { NovovilleButton, Typography } from '@/components/novoville';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { toast } from '@/components/ui/use-toast';
import '../../output.css';
import { setCameFrom } from '../home/actions';
import AuthPageContainer from './AuthPageContainter';
import { postLogin } from './actions';

// Ensure this path is correct based on your project structure

const LoginConfirmationPage = ({ history }) => {
  const { code, email } = store.getState().authReducer;
  const cameFromRegistration =
    store.getState().router?.location?.state?.from === '/registration-page';

  const dispatch = useDispatch();

  const initialLanguage = getLanguage();

  const [selectedLanguage, setSelectedLanguage] = useState(
    initialLanguage || ''
  );

  const handleLanguageChange = async (newLanguage) => {
    setSelectedLanguage(newLanguage);
    await dispatch(setLanguage(newLanguage));
  };

  const firstCheckDone = useRef(false);

  const navigate = useCallback(
    (path) => {
      history.replace(path);
    },
    [history]
  );

  useEffect(() => {
    if (!firstCheckDone.current) {
      firstCheckDone.current = true;
      return;
    }

    if (!code || !email) {
      navigate('/hello');
    }
  }, [code, email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(postLogin());
      dispatch(setCameFrom('login'));
      return dispatch(goToAuthorityOrMainApp());
    } catch (error) {
      toast({
        title: translate('Error'),
        description: translate(error),
        variant: 'destructive',
      });
    }
  };

  return (
    <AuthPageContainer
      language={selectedLanguage}
      handleLanguageChange={handleLanguageChange}
    >
      <Card className="w-full h-full sm:p-[40px] sm:drop-shadow-md drop-shadow-none shadow-none text-gray-800 px-[24px] border-none">
        <form className="h-full flex flex-col" onSubmit={handleSubmit}>
          <CardContent className="mb-8 p-0 flex flex-col space-y-3">
            <div className="h-20 w-20 mb-5 flex justify-center items-center rounded-sm bg-gainsBoro mx-auto">
              <Mail className="text-darkBlueishGray h-8 w-8" />
            </div>
            <Typography variant={'bold_32'} className="text-center">
              {translate('Check Your Email!')}
            </Typography>
            <Typography variant={'regular_16'} className="text-center">
              {cameFromRegistration ? (
                <>
                  {translate('We have sent an email message to your address')}
                  <strong> {email}. </strong>
                  {translate(
                    'Please check your inbox, confirm your email and then continue.'
                  )}
                </>
              ) : (
                translate(
                  'We have sent you an email message. Please check your inbox and click on the button “Confirm”.'
                )
              )}
            </Typography>
          </CardContent>
          <CardFooter className="p-0 flex flex-col justify-center items-center mt-auto">
            {!cameFromRegistration && (
              <NovovilleButton
                type="submit"
                variant="primary"
                className="w-full mb-4"
              >
                {translate('I have done this connect me')}
              </NovovilleButton>
            )}
            {cameFromRegistration && (
              <div className="flex flex-col w-full mb-4">
                <NovovilleButton
                  type="submit"
                  variant="primary"
                  className="w-full mb-4"
                >
                  {translate('Continue')}
                </NovovilleButton>
                <NovovilleButton
                  variant="secondary"
                  className="w-full"
                  onClick={() => navigate('/hello')}
                >
                  {translate('alert.cancel')}
                </NovovilleButton>
              </div>
            )}
          </CardFooter>
        </form>
      </Card>
    </AuthPageContainer>
  );
};

export default withRouter(LoginConfirmationPage);
